import Icon, { IconProps } from '@/components/elements/Icon';

export type AngleDownProps = IconProps;

/**
 * @component AngleDown
 */
function AngleDown({ ...rest }: AngleDownProps) {
  return (
    <Icon viewBox="0 0 24 24" useStroke {...rest}>
      <path
        stroke="none"
        d="M7.00005 10.5892L11.2901 14.8292C11.383 14.9229 11.4936 14.9973 11.6155 15.0481C11.7373 15.0989 11.868 15.125 12.0001 15.125C12.1321 15.125 12.2628 15.0989 12.3846 15.0481C12.5065 14.9973 12.6171 14.9229 12.7101 14.8292L16.9501 10.5892C17.0438 10.4962 17.1182 10.3856 17.1689 10.2638C17.2197 10.1419 17.2458 10.0112 17.2458 9.8792C17.2458 9.74719 17.2197 9.61648 17.1689 9.49463C17.1182 9.37277 17.0438 9.26217 16.9501 9.1692C16.7627 8.98295 16.5092 8.87841 16.2451 8.87841C15.9809 8.87841 15.7274 8.98295 15.5401 9.1692L12.0001 12.7092L8.46005 9.1692C8.27379 8.98446 8.02239 8.88031 7.76005 8.8792C7.62844 8.87844 7.49798 8.90367 7.37614 8.95343C7.25431 9.0032 7.14349 9.07652 7.05005 9.1692C6.95298 9.25882 6.87462 9.36679 6.81951 9.48686C6.76441 9.60694 6.73364 9.73674 6.72899 9.86878C6.72434 10.0008 6.7459 10.1325 6.79243 10.2561C6.83895 10.3798 6.90952 10.493 7.00005 10.5892Z"
      />
    </Icon>
  );
}

export default AngleDown;
